import ApiService from "../../../../../services/ApiService";
import translate from "../../../../../services/Translate";

export const addUsersFlags = (
  language: string,
  cohortId: string,
  userIds: number[],
  flagIds: number[],
  setIsAdding: Function,
  successCallback?: Function,
  isCohortScoped: boolean = false
) => {
  setIsAdding(true);
  ApiService.post(`cohorts/${cohortId}/users/flags/batch`, {
    user_ids: userIds,
    flag_ids: flagIds,
    is_cohort_scoped: isCohortScoped,
  })
    .then((_) => {
      alert(translate(language, "PAGES.COHORT.USERS.MODALS.ADD_FLAGS_TO_USERS.ALERTS.SUCCESS"));
      successCallback?.();
    })
    .catch((error) => {
      console.error("Error updating user flags", error);
      alert(translate(language, "PAGES.COHORT.USERS.MODALS.ADD_FLAGS_TO_USERS.ALERTS.ERROR"));
    })
    .finally(() => setIsAdding(false));
};

export const removeUsersFlags = (
  language: string,
  cohortId: string,
  userIds: number[],
  flagIds: number[],
  setIsRemoving: Function,
  successCallback?: Function,
  isCohortScoped: boolean = false
) => {
  setIsRemoving(true);
  ApiService.delete(`cohorts/${cohortId}/users/flags/batch`, {
    user_ids: userIds,
    flag_ids: flagIds,
    is_cohort_scoped: isCohortScoped,
  })
    .then((_) => {
      alert(translate(language, "PAGES.COHORT.USERS.REMOVE_FLAGS_FROM_USERS.ALERTS.SUCCESS"));
      successCallback?.();
    })
    .catch((error) => {
      console.error("Error removing user flags", error);
      alert(translate(language, "PAGES.COHORT.USERS.REMOVE_FLAGS_FROM_USERS.ALERTS.ERROR"));
    })
    .finally(() => setIsRemoving(false));
};

export const fetchFlags = (language: string, setFlags: Function, setIsFlagsLoading: Function) => {
  setIsFlagsLoading(true);
  ApiService.get("flags")
    .then((resp) => setFlags(resp.data.flags))
    .catch((error) => {
      console.error("Error fetching flags", error);
      alert(translate(language, "PAGES.COHORT.USERS.MODALS.ADD_FLAGS_TO_USERS.ALERTS.FETCH_FLAGS_ERROR"));
    })
    .finally(() => setIsFlagsLoading(false));
};
